import React, { useEffect, useState } from "react";
import { BehaviorSubject } from "rxjs";
import PropTypes from "prop-types";
import Article from "../../models/Article";
import TagPill from "../TagPill";

function TagList({ article, highlighted$, selected$, filterTagSet }) {
  const [filteredTags, setFilteredTags] = useState([]);
  const [otherTags, setOtherTags] = useState([]);

  useEffect(() => {
    if (filterTagSet.size === 0) {
      setFilteredTags([]);
      setOtherTags(article.uniqueTags);
    } else {
      setFilteredTags(
        article.uniqueTags.filter((x) => filterTagSet.has(x.typeKey))
      );
      setOtherTags(
        article.uniqueTags.filter((x) => !filterTagSet.has(x.typeKey))
      );
    }
  }, [filterTagSet]);

  return (
    <>
      {filteredTags.map((x) => (
        <TagPill
          countDesc={`${x.length}`}
          key={x.key}
          tag={x}
          highlighted$={highlighted$}
          selected$={selected$}
        />
      ))}

      {otherTags.map((x) => (
        <TagPill
          countDesc={`${x.length}`}
          key={x.key}
          tag={x}
          highlighted$={highlighted$}
          selected$={selected$}
        />
      ))}
    </>
  );
}

TagList.propTypes = {
  article: PropTypes.instanceOf(Article).isRequired,
  filterTagSet: PropTypes.instanceOf(Set),
  highlighted$: PropTypes.instanceOf(BehaviorSubject).isRequired,
  selected$: PropTypes.instanceOf(BehaviorSubject).isRequired,
};

TagList.defaultProps = {
  filterTagSet: new Set(),
};

export default TagList;
